import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRootStore from '@store/index';
import { TrackCallToAction } from '@store/index';
import { LinkComponent } from '@vg-constellation/angular-16/link';

import { AdviceBannerContent } from '../../services/content/content-jsons/advice-banner-content';

@Component({
  selector: 'app-advice-banner',
  templateUrl: './advice-banner.component.html',
  styleUrls: ['./advice-banner.component.scss'],
  standalone: true,
  imports: [LinkComponent],
})
export class AdviceBannerComponent implements OnInit {
  content = AdviceBannerContent;
  rightRail: Boolean;

  @Input() page: string;
  @Input() location: string;

  constructor(private globalStore: Store<fromRootStore.State>) {}

  ngOnInit() {
    this.rightRail = this.location === 'rightRail';
  }

  adobeTrackingForLink() {
    const data = {
      location: `coo-inheritance-${this.page}`,
      ctaName: `coo-${this.page}-advice_banner`,
      ctaType: 'banner',
    };
    this.globalStore.dispatch(TrackCallToAction(data));
  }
}
